import { render, staticRenderFns } from "./TrendingAppItem.vue?vue&type=template&id=80e7dbd4"
import script from "./TrendingAppItem.vue?vue&type=script&lang=js"
export * from "./TrendingAppItem.vue?vue&type=script&lang=js"
import style0 from "./TrendingAppItem.vue?vue&type=style&index=0&id=80e7dbd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports